import PageLayout from './page-layout';
import PageContent from './page-content';

export { PageContent };
export default PageLayout;
